import { render, staticRenderFns } from "./ProjectDefinition.vue?vue&type=template&id=c00b7694&scoped=true&"
import script from "./ProjectDefinition.vue?vue&type=script&lang=js&"
export * from "./ProjectDefinition.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDefinition.vue?vue&type=style&index=0&id=c00b7694&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00b7694",
  null
  
)

export default component.exports